import { render, staticRenderFns } from "./ordersLost.vue?vue&type=template&id=7ec84ae2"
import script from "./ordersLost.vue?vue&type=script&lang=js"
export * from "./ordersLost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports